export default __webpack_public_path__ + "static/media/1516 spice rack top.9360758e.png";